export default "__VITE_ASSET__CTXOp5XT__"